import type { ReactNode } from "react";
import { cn } from "@web/lib/utils.ts";

export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-full flex-col items-center justify-center gap-2 px-8 text-center",
        className,
      )}
    >
      <h2 className="text-lg font-semibold tracking-tight text-text">{title}</h2>
      {description && <div className="max-w-sm text-sm text-muted">{description}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
